var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.275 4.75A2.725 2.725 0 017 2.025h8.839a.975.975 0 110 1.95H7a.775.775 0 00-.775.775v14.5c0 .428.347.775.775.775h8.839a.975.975 0 110 1.95H7a2.725 2.725 0 01-2.725-2.725V4.75z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.847 8.53a.975.975 0 011.368.17l2.804 3.6a.975.975 0 01-.77 1.574h-7.058a.975.975 0 010-1.95h5.064l-1.578-2.026a.975.975 0 01.17-1.368z",
    fill: "#495057"
  })));
}

export default SvgLogout24;